module.exports = __webpack_public_path__ + "staticfr/media/marcas (5).50ac4cd2.jpg";